import { Notification } from "@mantine/core";
import { NOTIFICATION_VARIANTS } from "./notificationVariants";

export default function CustomNotificationBanner({
  variant = "info",
  title,
  message,
  titleColor,
  descriptionColor,
  withCloseButton = true,
  onClose,
  ...props
}) {
  const { Icon, iconColor, bg, mantineColor } =
    NOTIFICATION_VARIANTS[variant] ?? NOTIFICATION_VARIANTS.info;

  return (
    <Notification
      title={title}
      color={mantineColor}
      icon={<Icon size={18} color={iconColor} />}
      withCloseButton={withCloseButton}
      onClose={onClose}
      styles={{
        root: { backgroundColor: bg },
        title: {
          color: titleColor || "var(--mantine-color-black)",
        },
        description: {
          color: descriptionColor || "var(--mantine-color-neutral-3)",
        },
      }}
      {...props}
    >
      {message}
    </Notification>
  );
}
